"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderTypes = void 0;
var SliderTypes;
(function (SliderTypes) {
    SliderTypes["ParticipatingGames"] = "ParticipatingGames";
    SliderTypes["LatestWinners"] = "LatestWinners";
})(SliderTypes = exports.SliderTypes || (exports.SliderTypes = {}));
;
